import React from "react";
import { Form } from "react-final-form";
import { FORM_ERROR } from "final-form";
import { useSelector, useDispatch } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import { Button, Toast } from "@ebsco-ui/ebsco-ui";
import sharedMessages from "../../../../shared-messages";
import submitErrorFieldsHaveChanged from "../../../utils/submit-error-fields-have-changed";
import {
  getSecretQuestionCode,
  savePersonalUserSuccess
} from "../../../store/personal-user";
import { useEdgeApiContext } from "../../edge-api";
import SecretQuestionSelect from "../../secret-question-select";
import FormErrorNotification from "../../form-error-notification";
import messages from "./secret-question-update-form-messages";

import "./secret-question-update-form.scss";

const block = "secret-question-update-form";

const SecretQuestionUpdateForm = props => {
  const personalUserApi = useEdgeApiContext();
  const { formatMessage } = useIntl();
  const secretQuestionCode = useSelector(getSecretQuestionCode);
  const dispatch = useDispatch();

  const onSubmit = async (data, { reset }) => {
    let formErrors;
    try {
      await personalUserApi.putPersonalUser(data);
      const { secretQuestionCode } = data;
      dispatch(savePersonalUserSuccess({ secretQuestionCode }));
      Toast(formatMessage(messages.success), {
        closeButton: false,
        type: "success"
      });
      const { secretQuestionAnswer, ...newInitialValues } = data;
      setTimeout(() => reset(newInitialValues));
    } catch (error) {
      formErrors = {
        [FORM_ERROR]: {
          headerMessage: formatMessage(sharedMessages.somethingWentWrong),
          descriptionMessage: formatMessage(messages.failure)
        }
      };
    }
    return formErrors;
  };

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{ secretQuestionCode, isCoppa: true }}
    >
      {({
        dirty,
        dirtyFieldsSinceLastSubmit,
        handleSubmit,
        submitting,
        submitError,
        submitErrors,
        submitFailed
      }) => {
        const disableSave =
          submitting ||
          !(submitFailed
            ? submitErrorFieldsHaveChanged(
                submitErrors,
                dirtyFieldsSinceLastSubmit
              )
            : dirty);
        return (
          <form onSubmit={handleSubmit} className={block}>
            {submitError && <FormErrorNotification {...submitError} />}
            <SecretQuestionSelect />
            <Button
              type="submit"
              className="save-button"
              disabled={disableSave}
              styleType="solid"
            >
              <FormattedMessage {...sharedMessages.save} />
            </Button>
          </form>
        );
      }}
    </Form>
  );
};

export default SecretQuestionUpdateForm;
